<template>
  <div class="air_ListBox">
    <div class="search-form">
      <el-row type="flex" :gutter="20" align="middle">
        <el-col class="el-col-label" :span="8">
          <span>PNR:</span>
          <input clearable v-model="searchForm.pnr" @keyup.13="getList">
        </el-col>
        <el-col class="el-col-label" :span="8">
          <span>订单号:</span>
          <input clearable v-model="searchForm.orderNo" @keyup.13="getList">
        </el-col>
        <el-col class="el-col-label" :span="8">
          <span>票号:</span>
          <input clearable v-model="searchForm.ticketNumber" @keyup.13="getList">
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex" align="middle" style="margin-top:10px;">
        <el-col class="el-col-label" :span="8">
          <span>乘客姓名:</span>
          <input clearable v-model="searchForm.psgName" @keyup.13="getList">
        </el-col>
        <el-col class="el-col-label" :span="8">
          <span>航班日期:</span>
          <el-date-picker
            v-model="searchForm.beginDate"
            type="date"
            placeholder=""
            value-format="yyyy-MM-dd"
            class="time_box"
            @change="getList"
          ></el-date-picker>
        </el-col>
      </el-row>
      <div class="btn_box">
        <el-button type="primary" @click="getList" size="small">搜索</el-button>
        <el-button type="" @click="recharge" size="small">重置</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span="24">
        <div class="table-nav flex-center">
          <div
            class="nav-item cursor"
            v-for="(item,index) in tabelNav"
            :key="index"
            :class="{'nav-item-active':item.statu}"
            @click="getNavList(item,index)"
          >{{item.text}}</div>
          <div class="btn-batch">
            <el-button type="success" size="small" @click="applyBatch(applyBatchList)">批量申请行程单</el-button>
          </div>
        </div>
        <p class="table-nav-warning">温馨提示：请您在航班起飞后第15日之前申请行程单</p>
        <el-table
          :data="tableData"
          v-loading="loading"
          tooltip-effect="dark"
          style="width: 100%"
          class="font-12"
          @selection-change="changeList"
        >
          <el-table-column type="selection" width="55" :selectable="checkboxInit"></el-table-column>
          <el-table-column label="票号" class-name="fz12" align="center" width="100">
            <template slot-scope="scope">
              <p v-for="(ticket,index) in scope.row.ticketNumberList" :key="index">{{ticket}}</p>
            </template>
          </el-table-column>
          <el-table-column label="乘客姓名" class-name="fz12" align="left" prop="psgName"></el-table-column>
          <el-table-column label="订单号" class-name="fz12" align="center" width="100">
            <template slot-scope="scope">
              <span
                @click="setOrdersNo(scope.row.orderNo)"
                class="cursor orderLink"
              >{{scope.row.orderNo}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="出票日期"
            class-name="fz12"
            align="center"
            prop="ticketTime"
            width="90"
          ></el-table-column>
          <el-table-column label="PNR" class-name="fz12" align="center" prop="pnr" width="90">
            <template slot-scope="scope">
              <p>{{scope.row.segmentList[0].pnr}}</p>
            </template>
          </el-table-column>
          <el-table-column label="航程信息" width="150" class-name="fz12" align="center">
            <template slot-scope="scope">
              <!-- <div v-for="(flight,flightNoIndex) in scope.row.segmentList" :key="flightNoIndex">
                <p>
                  {{flight.depCityName+flight.depCityCode}}-
                  {{flight.arrCityName+flight.arrCityCode}}
                </p>
                <p>{{flight.flightNo}}</p>
              </div>-->
              <div
                v-for="(segmentEntity,segmentEntityIndex) in scope.row.segmentList"
                :key="segmentEntityIndex"
                @mouseenter="timeUpbox = scope.$index,offHeight($event)"
                @mouseleave="timeUpbox = null"
              >
                <p>{{segmentEntity.depCityName}}-{{segmentEntity.arrCityName}} {{segmentEntity.depDate}}</p>
                <FligthTime
                  :timeUpbox="timeUpbox"
                  :indexShow="scope.$index"
                  :listLength="scope.row.segmentDetailList.length"
                  :timeUpboxHeight="timeUpboxHeight"
                  :detailList="scope.row.segmentDetailList"
                />
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="航班日期" width="90" class-name="fz12" align="center">
            <template slot-scope="scope">
              <p v-for="(day,index) in scope.row.segmentTimeList" :key="index">{{day}}</p>
            </template>
          </el-table-column>-->
          <el-table-column label="最后申请时间" width="110" class-name="fz12" align="center">
            <template slot-scope="scope">{{scope.row.applyTime}}</template>
          </el-table-column>
          <el-table-column label="状态" class-name="fz12" align="center" prop="status"></el-table-column>
          <el-table-column label="配送信息" class-name="fz12" align="center">
            <template slot-scope="scope">
              <p>{{scope.row.mailingName|| '-------'}}</p>
              <p>{{scope.row.logisticsNum||'-------'}}</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90" class-name="fz12" align="center">
            <template slot-scope="scope">
              <!-- <el-button
                type="text"
                size="small"
              >查看订单</el-button>-->
              <el-button
                type="text"
                size="small"
                v-show="scope.row.status == '未申请'||scope.row.status=='即将到期'"
                @click="apply(scope.row,scope.row.itineraryNo,scope.row.ticketNumberList)"
              >申请行程单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-col style="margin-top:10px">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handlePageSize"
        background=""
        :current-page="searchForm.currentPage"
        :page-sizes="[10, 20, 30, 40,50]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalPage"
      ></el-pagination>
    </el-col>
  </div>
</template>

<script>
import itineraryList from "@/lib/data-service/flight/flight_domestic_buyer_manage_order_itinerary_list";
import scrollTop from "@/lib/common-service/scrollTop";
import FligthTime from "./component/flightTimeBox";
import { captureRejectionSymbol } from "events";

export default {
  data() {
    return {
      timeUpbox: null,
      timeUpboxHeight: null,
      searchForm: {
        currentPage: 1,
        pageSize: 10
      },
      list: [],
      totalPage: 0,
      tableData: [],
      tabelNav: [
        { text: "全部订单", statu: true, val: 1 },
        { text: "即将到期", statu: false, val: 2 },
        { text: "未申请", statu: false, val: 3 },
        { text: "不能申请", statu: false, val: 4 }
      ],
      loading: false,
      applyBatchList: []
    };
  },
  components: { FligthTime },
  activated() {
    this.getList();
  },
  methods: {
    //获取列表
    getList() {
      let data = this.searchForm;
      this.loading = true;
      itineraryList(data).then(res => {
        this.loading = false;
        this.tableData = res.pageResult.pageData;
        this.totalPage = res.pageResult.totalCount;
        scrollTop(500);
      });
    },
    checkboxInit(row, index) {
      if (row.status === "未申请" || row.status === "即将到期") {
        return true;
      } else {
        return false;
      }
    },
    //表格类型搜索
    getNavList(val, index) {
      let data = this.searchForm;
      this.tabelNav.map(item => {
        item.statu = false;
      });
      this.$nextTick(() => {
        this.tabelNav[index].statu = true;
      });
      data.status = val.val;
      this.getList();
    },
    changeList(val) {
      this.applyBatchList = val;
    },
    handlePageSize(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.currentPage = val;
      this.getList();
    },
    offHeight(e) {
      this.timeUpboxHeight = e.target.offsetParent.offsetHeight;
      // e.fromElement.localName == "td" ? e.fromElement.offsetHeight : 0;
    },
    //重置
    recharge() {
      this.searchForm = {};
      this.searchForm.currentPage = 1;
      this.searchForm.pageSize = 10;
      this.getList();
    },
    setOrdersNo(val) {
      this.$router.push({
        name: "air-ticket-admin-airDetails",
        query: {
          ordersNo: val
        }
      });
    },
    apply(val, itineraryNo, ticketNumberList) {
      let obj = {
        psgNo: val.psgNo,
        ticketNumber: val.ticketNumberList[0]
      };
      obj = JSON.stringify(obj);
      this.$router.push({
        name: "air-ticket-admin-strokeOrderInfo",
        query: {
          // psgNo: val,
          // itineraryNo: itineraryNo,
          // ticketNumberList: ticketNumberList.join(",")
          dataInfo: obj
        },
        params: { refresh: 1 }
      });
    },
    applyBatch(val) {
      if (val.length == 0) return;

      let dataArr = val.map(item => {
        return {
          psgNo: item.psgNo,
          ticketNumber: item.ticketNumberList[0]
        };
      });
      dataArr = JSON.stringify(dataArr);
      // let arr = val.map(item => {
      //   return item.psgNo;
      // });
      // let ticketNumberList = val.map(item => {
      //   return item.ticketNumberList;
      // });
      this.$router.push({
        name: "air-ticket-admin-strokeOrderInfo",
        query: {
          // psgNoAll: arr.join(","),
          // ticketNumberList: ticketNumberList.join(",")
          dataInfo: dataArr
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.air_ListBox {
  border-top: 3px solid #237dc9;
  width: 100%;
}
.el-button {
  border-radius: 0;
}
.search-form {
  padding: 20px;
  margin-bottom: 10px;
  background: #f4f9ff;
  span {
    width: 75px;
    font-size: 14px;
    display: inline-block;
  }
  .el-col-label {
    input {
      display: inline-block;
      border: 1px solid #dcdfe6;
      font-size: inherit;
      height: 30px;
      border-radius: 0;
      width: 180px;
      font-size: 12px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      box-sizing: border-box;
    }
    /deep/.el-input__inner {
      display: inline-block;
      border: 1px solid #dcdfe6;
      font-size: inherit;
      height: 30px;
      border-radius: 0;
      width: 180px;
      font-size: 12px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      box-sizing: border-box;
    }
    /deep/.el-input__icon {
      line-height: 30px;
    }
    /deep/.el-date-editor.el-input {
      width: unset;
      display: inline-block;
    }
    .time_box /deep/.el-input__inner {
      padding: 0 30px;
      line-height: 30px;
    }
  }
}
.btn_box {
  margin: 0 auto;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  position: relative;
}
.nav_tab {
  /deep/.el-tabs__nav-wrap {
    background: #f1f4fb;
    padding: 0 20px;
  }
  /deep/.el-tabs__nav-wrap::after {
    background-color: unset;
  }
  /deep/.el-tabs__item.is-active {
    font-size: 12px;
    background: #fff;
    padding: 0 15px;
  }
  /deep/.el-tabs__item {
    font-size: 12px;
  }
  /deep/.el-tabs__active-bar {
    box-sizing: content-box;
    padding: 0 15px;
    top: 0;
    height: 3px;
    left: -15px;
  }
}
.fz12 {
  font-size: 12px;
  button {
    margin: 0;
  }
}
.table-nav {
  justify-content: flex-start;
  padding: 0 10px;
  background: #f1f4fb;
  color: #7c7d7d;
  font-size: 14px;
  margin-top: 10px;
  position: relative;
  .btn-batch {
    position: absolute;
    right: 10px;
  }
  .nav-item {
    padding: 8px 20px;
    &:hover {
      color: #237dc9;
    }
  }
  .nav-item-active {
    color: #237dc9;
    background: white;
    border-top: 3px solid #237dc9;
  }
}
.table-nav-warning {
  color: red;
  font-size: 14px;
  text-align: end;
  padding: 5px 0;
}
.orderLink {
  color: #237dc9;
}
</style>
